<i18n lang="yaml">
en:
  teaserButton1: 'Create account'
  teaserButton2: 'Get advice'
  tabTitle1: 'Preconfigured Servers'
  tabTitle2: 'Configurator'
  sectionTitle1: 'Selectel Dedicated Servers'
  sectionTitle2: 'Pay in advance and get a discount'
  sectionTitle3: 'Our data centers in&nbsp;Moscow, St. Petersburg and the Leningrad region'
  sectionTitle4: 'They trust us'
  sectionTitle5: 'Documentation'
  sectionSubtitle1: 'Whichever server you choose, we&nbsp;will place it&nbsp;in&nbsp;a&nbsp;Tier III data center, providing physical and data security, network connectivity, uninterrupted power supply, stable microclimate, and premium quality support.'
  sectionSubtitle2: 'More than 18,000 customers around the world have built their infrastructure using Selectel products, each with its own story.'
  sectionSubtitle3: 'We&rsquo;ve gathered all important documents and instructions in&nbsp;one place to&nbsp;make it&nbsp;easier for you to&nbsp;get started with our dedicated servers.'
ru:
  teaserButton1: 'Создать аккаунт'
  teaserButton2: 'Получить консультацию'
  tabTitle1: 'Готовые конфигурации'
  tabTitle2: 'Конфигуратор'
  sectionTitle1: 'Выделенные серверы Selectel'
  sectionTitle2: 'При единовременной оплате — выгодно'
  sectionTitle3: 'Наши дата-центры в Москве, Санкт-Петербурге и&nbsp;Ленинградской области'
  sectionTitle4: 'Компании, которые нам доверяют'
  sectionTitle5: 'Документация'
  sectionSubtitle1: 'Какой&nbsp;бы сервер вы&nbsp;ни&nbsp;выбрали, мы&nbsp;разместим его в&nbsp;дата-центре уровня Tier III ― обеспечим физическую и&nbsp;информационную безопасность, сетевую доступность, проследим за&nbsp;бесперебойностью электричества и&nbsp;микроклиматом, окажем поддержку премиального качества.'
  sectionSubtitle2: 'Более 18&nbsp;000 клиентов по&nbsp;всему миру построили свою инфраструктуру с&nbsp;продуктами Selectel, и&nbsp;у&nbsp;каждого своя история.'
  sectionSubtitle3: 'Мы&nbsp;собрали все важные документы и&nbsp;инструкции в&nbsp;одном месте, чтобы вам было удобно начать работу с&nbsp;выделенными серверами.'
</i18n>

<template>
  <div class="page">
    <teaser
      :title="pageTitle"
      :teaser="teaser"
      :svg-background="require('~/assets/images/components/teaser/background/server.svg?inline').default"
    >
      <template #buttons>
        <a
          href="https://my.selectel.ru/registration?destination=/servers/order/pre-built"
          class="btn btn--dark"
          v-html="$t('teaserButton1')"
        ></a>
        <button
          class="btn btn--outline"
          @click="openJivoChat"
          v-html="$t('teaserButton2')"
        ></button>
      </template>
    </teaser>

    <s-section
      id="table"
      :title="$t('sectionTitle1')"
      :subtitle="$t('sectionSubtitle1')"
    >
      <dedicated-servers-table></dedicated-servers-table>

      <s-section
        id="preconfigured"
        class="servers-configurator"
        is-sub-section
      >
        <a-tabs
          v-model="currentTab"
          default-active-key="filter"
          force-render
          class="mb-4"
        >
          <a-tab-pane
            key="filter"
            force-render
          >
            <span
              slot="tab"
              data-gtmid="gtm-selectel-server-tab-fix"
              v-html="$t('tabTitle1')"
            ></span>

            <dedicated-configurations class="servers-configurator__wrapper--in-tabs"></dedicated-configurations>
            <dedicated-configurations-on-server class="servers-configurator__wrapper--on-server"></dedicated-configurations-on-server>
          </a-tab-pane>
          <a-tab-pane
            key="configurator"
            force-render
          >
            <span
              slot="tab"
              data-gtmid="gtm-selectel-server-tab-custom"
              v-html="$t('tabTitle2')"
            ></span>
            <div class="row">
              <div class="col-xl-9 ml-auto">
                <configurator
                  v-if="configuratorIsReady"
                  class="servers-configurator__iframe"
                ></configurator>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </s-section>

      <dedicated-sales
        :title="$t('sectionTitle2')"
      ></dedicated-sales>
    </s-section>

    <content-widget
      v-if="hasContentWidget"
      :content="contentWidget"
    ></content-widget>

    <s-section
      :title="$t('sectionTitle3')"
      has-outside-content
    >
      <data-center-list :data-centers="dataCenters"></data-center-list>
    </s-section>

    <s-section
      class="clients"
      :title="$t('sectionTitle4')"
      :subtitle="$t('sectionSubtitle2')"
    >
      <customer-logos
        v-if="hasCustomerLogos"
        :customer-logos="customerLogos"
      ></customer-logos>

      <card-slider
        v-if="hasStories"
        :cards-data="stories"
      ></card-slider>
    </s-section>

    <s-section
      :title="$t('sectionTitle5')"
      :subtitle="$t('sectionSubtitle3')"
    >
      <resources
        v-if="hasResources"
        :resources="resources"
      ></resources>

      <documents
        v-if="hasDocuments"
        :documents="documents"
      ></documents>
    </s-section>

    <faq
      v-if="hasFaq"
      :faq="faq"
    ></faq>

    <s-section type="gray">
      <consultation link="https://my.selectel.ru/registration?destination=/servers/order/pre-built"></consultation>
    </s-section>
  </div>
</template>

<script>
import PageComponents from '~/mixins/page/page-components'
import PageSeo from '~/mixins/page/page-seo'
import JivoUtils from '~/mixins/jivo-utils'

import Teaser from '~/components/teaser/Teaser'
import DedicatedServersTable from '~/components/tables/DedicatedServersTable'
import DedicatedConfigurations from '~/components/configurations/dedicated/DedicatedConfigurations'
import Configurator from '~/components/configurators/DedicatedIframeConfigurator'
import DataCenterList from '~/components/single/data-center/DataCenterList'
import DedicatedSales from '~/components/single/dedicated/DedicatedSales'
import ContentWidget from '~/components/common/content-widget/ContentWidget'
import CustomerLogos from '~/components/common/customer-logos/CustomerLogos'
import CardSlider from '~/components/common/card-slider/CardSlider'
import Resources from '~/components/common/resources/Resources'
import Documents from '~/components/common/documents/Documents'
import Faq from '~/components/common/faq/Faq'
import Consultation from '~/components/single/Consultation'
import DedicatedConfigurationsOnServer from '@/components/configurations/dedicated/DedicatedConfigurationsOnServer'

export default {
  async asyncData(ctx) {
    const {app, $http, error} = ctx

    try {
      const page = await $http.$get(`${app.wp}/v2/pages/slug/dedicated`)
      const dataCenters = await $http.$get(`${app.wp}/v2/data_centers`)

      return {page, dataCenters}
    } catch (err) {
      error(err)
    }
  },
  name: 'PageDedicated',
  components: {
    DedicatedConfigurationsOnServer,
    Teaser,
    DedicatedServersTable,
    DedicatedConfigurations,
    Configurator,
    DataCenterList,
    DedicatedSales,
    ContentWidget,
    CustomerLogos,
    CardSlider,
    Resources,
    Documents,
    Faq,
    Consultation
  },
  mixins: [
    PageComponents,
    PageSeo,
    JivoUtils
  ],
  data() {
    return {
      currentTab: 'filter',
      configuratorIsReady: false
    }
  },
  mounted() {
    this.$events.$on('dedicatedServersEvent', payload => {
      this.changeActiveTab(payload)
    })
    this.configuratorIsReady = true
  },
  methods: {
    changeActiveTab(payload) {
      if (payload === 'isConfigurator') {
        this.currentTab = 'configurator'
      } else {
        this.currentTab = 'filter'
      }
    }
  }
}
</script>

<style lang="scss">
.servers-configurator {
  .ant-tabs-nav-wrap {
    padding-left: calc(100% / 12 * 3);

    @media (max-width: $breakpoint-xl) {
      padding-left: 0;
    }
  }

  .ant-tabs .ant-tabs-bottom-content > .ant-tabs-tabpane-inactive,
  .ant-tabs .ant-tabs-top-content > .ant-tabs-tabpane-inactive {
    height: auto;
    max-height: 0;
  }
}

.servers-configurator__iframe {
  padding-top: 24px;
}
</style>